import styled from 'styled-components';
import ReactSelect from 'react-select';
import { pickColor } from 'themes/helpers/pickColor';

const Container = styled.div`
  display: flex;
`;

const Label = styled.label`
  padding: 1rem 2rem 1rem 0;
  width: 14rem;

  font-weight: 600;
  font-family: 'LFT Zeno Condensed', sans-serif;
  font-size: 1.6rem;

  letter-spacing: 0.1rem;
  text-transform: uppercase;

  color: ${pickColor('black')};
`;

const Select = styled(ReactSelect)`
  flex-grow: 1;
`;

export { Container, Label, Select };
